import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold mb-4">同人创作指南</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              专注同人漫画创作技巧、发布平台与版权知识的综合性指南网站，助力每一位二次元爱好者的创作之路。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信公众号">
                <i className="ri-wechat-line text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold mb-4 text-foreground-300 uppercase tracking-wide">内容分类</h3>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold mb-4 text-foreground-300 uppercase tracking-wide">推荐阅读</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/tongren-manhua-jiaoben-rumen" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  同人漫画脚本入门
                </Link>
              </li>
              <li>
                <Link to="/article/manhua-fenjing-goutu-faze" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  漫画分镜构图法则
                </Link>
              </li>
              <li>
                <Link to="/article/guonei-tongren-tougao-pingtai" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  国内投稿平台全攻略
                </Link>
              </li>
              <li>
                <Link to="/article/tongren-chuangzuo-banquan-jichu" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  同人创作版权基础
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold mb-4 text-foreground-300 uppercase tracking-wide">关于我们</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
            <p className="text-xs text-foreground-500 mt-5">
              联系邮箱：contact@doujin-guide.com
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 同人创作指南. 本站为同人创作知识分享平台，内容仅供参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}